export default {
}



// WEBPACK FOOTER //
// ./src/app/dweller/visitor/index/resources/computed.js